import moment from "moment";


export const capitalizeFullName = (name: string): string => {
  if (!name) return "";

  return name
    .trim()
    .split(/\s+/) // split by any amount of spaces
    .map(
      word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};


export const apiPageLimit = 12;

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB in bytes
export const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50 MB in bytes
export const MAX_FILES = 5;


export const formatLocalDate = (date: Date | null) => {
  if (!date) return null;
  return moment(date).format("YYYY-MM-DD");
};


export const capitalizeFullRole = (name: string): string => {
  if (!name) return "";

  return name
    .trim()
    .replace(/_/g, " ") // replace underscores with spaces
    .split(/\s+/) // split by any number of spaces
    .map(
      word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};


export const formatOwnership = (text:string) => {
  if (!text) return "";

  return text
    .split(/[-\s]+/)              // split on hyphens or spaces
    .map(
      (word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};

export const getPlanNameFromAppleId = (productId: string) => {
  if (!productId) return null;
 
  const match = productId.match(/(basic|pro|investor)/i);
  if (!match) return null;
 
  const plan = match[1].toLowerCase();
  return plan.charAt(0).toUpperCase() + plan.slice(1);
};
